import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import { SectionTitle } from 'components/sectionTitle';
import Button from 'components/button';
import shapeImg from 'assets/images/bg/RoadMapV2Fram.png';
import RoadMapItem from './RoadMapItem/RoadMapItem';
import RoadMapStyleWrapper from './RoadMap.style';
import checkIcon from 'assets/images/kycimg/RMcheckicon.svg';
import { useTranslation } from 'react-i18next';

const RoadMap = () => {
  const { t } = useTranslation();

  const data = [
    {
      year: '2024',
      items: [
        {
          title: 'Q1 2024',
          isLunched: true,
          checkList: [
            { icon: checkIcon, text: t('roadmap.roadmap1') },
            { icon: checkIcon, text: t('roadmap.roadmap2') },
            { icon: checkIcon, text: t('roadmap.roadmap3') },
          ],
        },
        {
          title: 'Q2 2024',
          isLunched: true,
          checkList: [{ icon: checkIcon, text: t('roadmap.roadmap4') }],
        },
        {
          title: 'Q3 2024',
          isLunched: true,
          checkList: [{ icon: checkIcon, text: t('roadmap.roadmap5') }],
        },
        {
          title: 'Q4 2024',
          isLunched: true,
          checkList: [{ icon: checkIcon, text: t('roadmap.roadmap6') }],
        },
      ],
    },
    {
      year: '2025',
      items: [
        {
          title: 'Q1 2025',
          isLunched: true,
          checkList: [
            { icon: checkIcon, text: t('roadmap.roadmap2025_q1_1') },
            { icon: checkIcon, text: t('roadmap.roadmap2025_q1_2') },
          ],
        },
        {
          title: 'Q2 2025',
          isLunched: true,
          checkList: [
            { icon: checkIcon, text: t('roadmap.roadmap2025_q2_1') },
            { icon: checkIcon, text: t('roadmap.roadmap2025_q2_2') },
          ],
        },
        {
          title: 'Q3 2025',
          isLunched: true,
          checkList: [
            { icon: checkIcon, text: t('roadmap.roadmap2025_q3_1') },
            { icon: checkIcon, text: t('roadmap.roadmap2025_q3_2') },
          ],
        },
        {
          title: 'Q4 2025',
          isLunched: false,
          checkList: [
            { icon: checkIcon, text: t('roadmap.roadmap2025_q4_1') },
            { icon: checkIcon, text: t('roadmap.roadmap2025_q4_2') },
          ],
        },
      ],
    },
    {
      year: '2026',
      items: [
        {
          title: 'Q1 2026',
          isLunched: false,
          checkList: [
            { icon: checkIcon, text: t('roadmap.roadmap2026_q1_1') },
            { icon: checkIcon, text: t('roadmap.roadmap2026_q1_2') },
          ],
        },
        {
          title: 'Q2 2026',
          isLunched: false,
          checkList: [
            { icon: checkIcon, text: t('roadmap.roadmap2026_q2_1') },
            { icon: checkIcon, text: t('roadmap.roadmap2026_q2_2') },
          ],
        },
        {
          title: 'Q3 2026',
          isLunched: false,
          checkList: [
            { icon: checkIcon, text: t('roadmap.roadmap2026_q3_1') },
            { icon: checkIcon, text: t('roadmap.roadmap2026_q3_2') },
          ],
        },
        {
          title: 'Q4 2026',
          isLunched: false,
          checkList: [
            { icon: checkIcon, text: t('roadmap.roadmap2026_q4_1') },
            { icon: checkIcon, text: t('roadmap.roadmap2026_q4_2') },
          ],
        },
      ],
    },
  ];

  return (
    <RoadMapStyleWrapper>
      <div className="container">
        <SectionTitle
          title={t('roadmap.title')}
          subtitle={t('roadmap.subtitle')}
        />

        <div className="roadmap_content">
          <Tabs defaultIndex={1}>
            <TabList>
              {data?.map((item, i) => (
                <Tab key={i}>
                  <Button
                    href="#"
                    variant="outline"
                    sm
                    onClick={(e) => e.preventDefault()}
                  >
                    {item.year}
                  </Button>
                </Tab>
              ))}
            </TabList>

            {data?.map((roadMaps, i) => (
              <TabPanel key={i} className="row tabs-row">
                {roadMaps.items?.map((roadMap, j) => (
                  <div key={j} className="col-md-4">
                    <RoadMapItem {...roadMap} />
                  </div>
                ))}
              </TabPanel>
            ))}
          </Tabs>
        </div>
      </div>

      <img
        src={shapeImg}
        alt="section-shape"
        className="img-fluid section_shape section_shape_top"
      />
      <img
        src={shapeImg}
        alt="section-shape"
        className="img-fluid section_shape section_shape_bottom"
      />
    </RoadMapStyleWrapper>
  );
};

export default RoadMap;
